import {
  SaveQueryRequest,
  SaveQueryResponse,
  DataQuery,
  APIResponse,
  ResolveName,
} from '../../utils/types';
import { apiPrefix } from '../../utils/functions';

export const fetchDataQueries = async (
  project_id: number | undefined,
): Promise<DataQuery[]> => {
  try {
    const response = await fetch(
      apiPrefix() + '/v1/fetch_data_query?project=' + project_id,
      {
        method: 'GET',
        credentials: 'include',
      },
    );
    if (!response.ok) throw new Error('Failed to fetch data queries');

    const data: APIResponse<DataQuery> = await response.json();
    return data.data_queries;
  } catch (error) {
    console.error('Error fetching queries:', error);
    throw error;
  }
};

export const saveDataQuery = async (
  dataQuery: SaveQueryRequest,
): Promise<SaveQueryResponse> => {
  try {
    console.log('API URL: ' + apiPrefix());
    const response = await fetch(apiPrefix() + '/v1/add_data_query', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(dataQuery),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to save data query');
    }

    return response.json();
  } catch (error) {
    console.error('Error saving data query:', error);
    throw error;
  }
};

export const deleteQuery = async (queryId: number | string): Promise<boolean> => {
  try {
    const response = await fetch(
      apiPrefix() + '/v1/delete_data_query?query_id=' + queryId,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      },
    );

    if (!response.ok) {
      throw new Error('Failed to delete query ID:' + queryId);
    }

    return true;
  } catch (error) {
    console.error('Error deleting query:', error);
    return false;
  }
};

export const ResolveSourceName = async (
  source_name: string | undefined,
): Promise<ResolveName> => {
  try {
    const response = await fetch(apiPrefix() + '/v1/resolve?source_name=' + source_name, {
      method: 'GET',
      credentials: 'include',
    });
    if (!response.ok) throw new Error('Failed to resolve source name: ' + source_name);

    const resolveResults = await response.json();
    return resolveResults;
  } catch (error) {
    console.error('Error resolving source name:', error);
    throw error;
  }
};
